import Modal from 'react-modal';
import React, { useRef } from 'react';
import { BsTrash } from 'react-icons/bs';
import { MdFileUpload } from 'react-icons/md';
import { MdOutlineClear } from 'react-icons/md';
import toast from 'react-hot-toast';
import { FaRegCopy } from 'react-icons/fa';

const AddSchematics = ({
  procedure,
  setProcedure,
  schematicView,
  setSchematicView,
}) => {
  const fileInputRef = useRef(null);

  const _saveImages = e => {
    const files = Array.from(e.target.files);

    const newImages = files.map(file => ({
      name: file.name,
      src: URL.createObjectURL(file),
      file: file,
    }));

    setProcedure(prev => ({
      ...prev,
      images: [...prev.images, ...newImages],
    }));
  };

  const handleNameChange = (index, newName) => {
    setProcedure(prev => {
      const updatedImages = prev.images.map((image, _index) =>
        _index === index ? { ...image, name: newName } : image
      );
      return { ...prev, images: updatedImages };
    });
  };

  const copyToClipboard = text => {
    navigator.clipboard.writeText(text).then(() => {
      toast.success('Copied to clipboard!');
    });
  };

  return (
    <Modal
      isOpen={schematicView}
      onRequestClose={() => setSchematicView(false)}
      style={{
        content: {
          marginTop: '5vh',
          marginLeft: '20vh',
          height: '70%',
          width: '65vw',
          transform: 'translate(10%, 10%)',
          overflow: 'overFlowY',
          overFlowX: 'hidden',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        },
      }}
    >
      <div className="h-full w-full flex flex-col">
        <div className="h-[5vh] w-full flex justify-end">
          <MdOutlineClear
            onClick={() => setSchematicView(false)}
            size={25}
            style={{ color: 'red', cursor: 'pointer' }}
          />
        </div>

        {procedure?.images?.length === 0 ? (
          <div className="h-[40vh] bg-gray-500 rounded rounded-sm flex flex-row justify-center items-center">
            <div
              className="flex flex-col items-center"
              style={{ cursor: 'pointer' }}
            >
              <input
                type="file"
                ref={fileInputRef}
                onChange={e => _saveImages(e)}
                hidden
                multiple
              />
              <label
                htmlFor="file-upload"
                className="relative inline-block cursor-pointer text-white rounded-md py-2 px-4 flex items-center justify-center hover:bg-blue-600 transition-all"
              >
                <div
                  className="flex flex-col items-center"
                  style={{ cursor: 'pointer' }}
                >
                  <MdFileUpload size={24} style={{ color: 'white' }} />
                  <span className="mr-2 text-white font-medium">
                    Upload Images
                  </span>
                </div>
                <input
                  id="file-upload"
                  type="file"
                  ref={fileInputRef}
                  onChange={e => _saveImages(e)}
                  className="absolute inset-0 opacity-0 cursor-pointer"
                  multiple
                />
              </label>
            </div>
          </div>
        ) : (
          ''
        )}

        {procedure?.images?.length !== 0 ? (
          <>
            <div className="flex flex-col items-center">
              <p className="text-gray-300">.</p>
              <input
                type="file"
                ref={fileInputRef}
                onChange={e => _saveImages(e)}
                hidden
                multiple
              />
              <label
                htmlFor="file-upload"
                className="relative inline-block cursor-pointer bg-blue-500 text-white rounded-md py-2 px-4 flex items-center justify-center hover:bg-blue-600 transition-all"
              >
                <span className="mr-2">Upload More Images</span>
                <MdFileUpload size={20} />
                <input
                  id="file-upload"
                  type="file"
                  ref={fileInputRef}
                  onChange={e => _saveImages(e)}
                  className="absolute inset-0 opacity-0 cursor-pointer"
                  multiple
                />
              </label>
            </div>

            <div className="w-full flex justify-start items-center gap-5 mt-6 mb-5">
              <div className="w-full overflow-auto">
                <div className="max-h-[53vh] overflow-y-auto border border-gray-300">
                <table className="w-full table-auto border-collapse">
                  <thead className="sticky top-0 bg-gray-200 z-10">
                    <tr>
                      <th className="border border-gray-300" scope="col">
                        Id
                      </th>
                      <th className="border border-gray-300" scope="col">
                        Name
                      </th>
                      <th
                        className="px-4 py-2 bg-gray-200 border border-gray-300"
                        scope="col"
                      >
                        Image
                      </th>
                      <th
                        className="px-4 py-2 bg-gray-200 border border-gray-300"
                        scope="col"
                      >
                        Delete
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {procedure.images.map((image, index) => (
                      <tr key={index}>
                        <td className="px-4 py-2 border border-gray-300 text-center">
                          {index + 1}
                        </td>
                        <td className="px-4 py-2 border border-gray-300 text-center">
                          <input
                            type="text"
                            value={image.name}
                            onChange={e =>
                              handleNameChange(index, e.target.value)
                            }
                            className="border border-gray-300 rounded px-2"
                          />
                          {image?.src.includes('bucket.s3') && (
                            <button
                              onClick={() => copyToClipboard(image?.src)}
                              className="relative group ml-2 text-gray-600 border border-gray-300 rounded p-1 hover:bg-gray-100"
                              aria-label="Copy link"
                              title="Click to copy link"
                            >
                              <FaRegCopy />
                            </button>
                          )}
                        </td>
                        <td className="px-4 py-2 border border-gray-300 text-center">
                          <div className="m-auto h-12 w-12 border border-black">
                            <img
                              src={image.src}
                              alt={`Preview ${index}`}
                              className="h-full w-full object-cover"
                            />
                          </div>
                        </td>
                        <td className="px-4 py-2 border border-gray-300 text-center">
                          <button
                            onClick={() =>
                              setProcedure(prev => ({
                                ...prev,
                                images: prev.images.filter(
                                  (_, _index) => _index !== index
                                ),
                              }))
                            }
                            className="bg-transparent border-none cursor-pointer"
                          >
                            <BsTrash color="#fe104d" />
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                </div>
              </div>
            </div>
          </>
        ) : (
          ''
        )}
      </div>
    </Modal>
  );
};

export default AddSchematics;
